import { useState } from "react";
import { useAxios } from "../../../utils/useAxios";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";

/**
 * @typedef {Object} LessonCreateDataType
 * @property {string} title - The title of the lesson
 * @property {string} description - The description of the lesson
 */

/**
 * Custom hook to create a new lesson
 */
export const useCreateLesson = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);
  const { axiosInstance } = useAxios();

  /**
   * @param {Object} params
   * @param {LessonCreateDataType} params.lessonData
   * @param {()=> void} [params.onSuccess]
   */
  const createLesson = async ({ lessonData, onSuccess }) => {
    setLoading(true);
    setError("");

    try {
      const response = await axiosInstance.post(
        `${TENANT_DOMAIN}/lesson/store`,
        lessonData,
      );
      setData(response.data);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      let firstErrorMessage = "";
      if (err?.response?.data?.errors) {
        firstErrorMessage = Object.values(err?.response?.data?.errors)[0][0];
      }

      if (err.status === 500) {
        firstErrorMessage = ERROR_MESSAGES.INTERNAL_SERVER;
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(
          firstErrorMessage ||
            err.response?.data?.message ||
            ERROR_MESSAGES.UNKNOWN,
        );
      }
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    createLesson,
    loading,
    error,
    data,
  };
};
